import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from '../../server-communication/running-actions/types/longRunningAction.decorator';

export class UpdateCurrentPassword {
   public static readonly type = '[ChangeOwnPassword] Update Current Password';

   constructor(public currentPassword: string) {}
}

export class UpdateNewPassword {
   public static readonly type = '[ChangeOwnPassword] Update New Password';

   constructor(public newPassword: string) {}
}

export class UpdateConfirmedPassword {
   public static readonly type = '[ChangeOwnPassword] Update Confirmed Password';

   constructor(public confirmedPassword: string) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.CHANGE_PASSWORD)
export class ChangeOwnPasswordNow {
   public static readonly type = '[ChangeOwnPassword] Change Own Password Now';

   constructor() {}
}

export class ResetPasswordEditing {
   public static readonly type = '[ChangeOwnPassword] Reset Password Editing';

   constructor() {}
}
